@if (mode !== 'none') {
  <div #overlay class="pp-overlay" [class.pp-overlay--locked]="mode === 'locked'">
    <div
      #dialog
      class="pp-dialog"
      [class.pp-dialog--locked]="mode === 'locked'"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="pp-title"
      aria-describedby="pp-body"
      tabindex="-1"
    >
      <div class="pp-icon" aria-hidden="true">
        @if (mode === 'locked') {
          <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="4" y="11" width="16" height="10" rx="2" />
            <path d="M8 11V7a4 4 0 0 1 8 0v4" />
          </svg>
        } @else {
          <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
          </svg>
        }
      </div>

      @if (mode === 'locked') {
        <h2 id="pp-title" class="pp-title" dir="auto">Account suspended</h2>
        <p id="pp-body" class="pp-body" dir="auto">
          Access to your Zeymo account has been suspended because your subscription is past due.
          Settle your subscription to restore access, or contact billing for help.
        </p>
      } @else {
        <h2 id="pp-title" class="pp-title" dir="auto">Your subscription has expired</h2>
        <p id="pp-body" class="pp-body" dir="auto">{{ message }}</p>
      }

      @if (portalError) {
        <p class="pp-error" role="alert" dir="auto">
          Could not open the billing portal. Email
          <a href="mailto:billing@zeymo.com">billing&#64;zeymo.com</a>.
        </p>
      }

      <div class="pp-actions">
        @if (mode === 'reminder' && canViewStatement) {
          <button type="button" class="pp-link pp-statement" (click)="onViewStatement()">
            View statement
          </button>
        }
        @if (mode === 'reminder') {
          <button
            type="button"
            class="pp-btn pp-btn--secondary pp-continue"
            [disabled]="secondsLeft > 0"
            (click)="onContinue()"
          >
            {{ continueLabel }}
          </button>
        } @else {
          <button type="button" class="pp-btn pp-btn--secondary pp-signout" (click)="onSignOut()">
            Sign out
          </button>
        }
        <button
          type="button"
          class="pp-btn pp-btn--primary pp-pay"
          [disabled]="isLoadingPortal"
          (click)="onPay()"
        >
          @if (isLoadingPortal) { Opening… }
          @else if (isStripe) { Pay now }
          @else { Contact billing }
        </button>
      </div>
    </div>
  </div>
}
